import * as runtypes from 'runtypes';

export const FeatureDecision = runtypes.Union(runtypes.Literal('enabled'), runtypes.Literal('disabled'));

export type FeatureDecision = runtypes.Static<typeof FeatureDecision>;
